/**
 * Alert service for module mwApp.show
 */

/**
 * alertSvc service <br>
 * Show alerts and confirms
 *
 * @class alertSvc
 * @memberof mwApp/show
 * @see mwApp/show
 *
 * @ngdoc service
 * @name mwApp/show.service:alertCustomSvc
 */
/* @ngInject */
export function AlertCustomSvc ($uibModal, $q, alertSvc) {
  // extends/replace alertSvc object with methods

  return {
    ...alertSvc,

    /**
     * Show confirm dialog with selection
     *
     * @memberof mwApp/show.service:AlertCustomSvc
     * @param {String} templateUrl - path to template
     * @param {Object|String} confirmMsg - object { header: '...', text: '...' } or single string
     * @param {String} confirmMsg.header - message header
     * @param {String} confirmMsg.text - message text
     * @return {Promise} promise
     */
    confirm: function (templateUrl, confirmMsg) {
      var result = $q.defer()
      $uibModal.open({
        animation: false,
        // scope: modalScope,
        backdropClass: 'modal-top modal-confirmation', // set z-index to 100500
        windowClass: 'modal-top modal-confirmation', // set z-index to 100510
        templateUrl: templateUrl,
        controller: 'ConfirmCustomDlgCtrl as vm',
        resolve: {
          msg: function () {
            return (typeof confirmMsg === 'string') ? { header: confirmMsg } : confirmMsg
          }
        },
        size: 'md'
      }).result
        .then(
          function close (data) {
            result.resolve(data)
          },
          function dismiss () {
            result.reject()
          }
        )
      return result.promise
    }
  }
}

/**
 * ConfirmCustomDlgCtrl controller
 * Shows confirm modal dialog
 *
 * @class ConfirmCustomDlgCtrl
 * @memberof mwApp/show
 * @see mwApp/show
 *
 * @ngdoc controller
 * @name mwApp/show.controller:ConfirmCustomDlgCtrl
 */
/* @ngInject */
export function ConfirmCustomDlgCtrl ($uibModalInstance, $sce, msg) {
  var vm = this

  /**
   * Dialog message
   *
   * @memberof mwApp/show.controller:ConfirmCustomDlgCtrl
   * @type {Object|String}
   */
  vm.msg = msg

  if (msg.header) {
    msg.header = $sce.trustAsHtml(msg.header)
  }
  if (msg.text) {
    msg.text = $sce.trustAsHtml(msg.text)
  }

  /**
   * Close modal confirmation dialog by choosing YES | OK
   *
   * @memberof mwApp/show.controller:ConfirmCustomDlgCtrl
   */
  vm.yes = function (data) {
    $uibModalInstance.close(data)
  }

  /**
   * Close modal confirmation dialog by choosing NO | CANCEL
   *
   * @memberof mwApp/show.controller:ConfirmCustomDlgCtrl
   */
  vm.no = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
